import groq from 'groq';
import { AssetFragment } from './image';
import { MiscTypes } from '$lib/sanity/types';
import { CardContentFragment } from './cardContent';

export const FileFragment = groq`
  ...,
    file {
      ${AssetFragment}
  }`;

export const GetFileQuery = groq`
  *[_type == "${MiscTypes.Document}" && slug.current == $slug][0]{
    ${FileFragment},
    ${CardContentFragment}
  }
`;
